export default "__VITE_ASSET__BwbhWDUu__"